import type { UsageListEntity } from '~/domain/Insurance/usageListEntity';
import type { UsageListResponseDTO } from '~/dto/Insurance/usageListDTO';

export const usageListResponseMapper = ({
  resultData,
}: UsageListResponseDTO): UsageListEntity => {
  return {
    success: true,
    usageList: resultData.map((item) => ({
      code: item.id,
      description: item.descricao,
    })),
  };
};
